var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jingzhunjiaoxue"},[_c('PublicCert',{attrs:{"logo":_vm.Logo4,"type":'jzjx',"color":'#159b7b'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }